import React from 'react';
import useWidthSetter from '../../CustomHooks/useWidthSetter';

const FullWidthPhoto = ({ photo, photoM, alt, caption }) => {
  const width = useWidthSetter();
  return (
    <div className="fullWidth">
      <img src={width >= 768 ? photo : photoM} alt={alt} />
      <p className="inline__caption__text">{caption}</p>
    </div>
  );
};

export default FullWidthPhoto;
